import axios from 'axios';
import { fileDownload } from 'utils/fileDownload';

import { translate } from 'hooks/translation/useTrls';

import { addMagritteCustomNotification, MagritteNotificationType } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

const SEGMENTS_REPORT_URL = '/api/v1/backoffice/yandex_segments_report';
const REPORT_FAILED_ERROR_KEY = 'YANDEX_SEGMENTS_REPORT_FAILED';

const TrlKeys = {
    failed: 'admin.directReport.segments.error.failed',
    downloadError: 'admin.report.DownloadError',
};

interface ReportErrors {
    errors?: Array<{ key: string; description?: string }>;
}

interface DownloadSegmentsReportParams {
    logins: string;
    dateFrom: string;
    dateTo: string;
}

const readBlobText = (blob: Blob): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = () => reject(reader.error);
        reader.readAsText(blob);
    });

const getFailedLogins = async (error: unknown): Promise<string | undefined> => {
    if (
        !axios.isAxiosError(error) ||
        !(error.response?.data instanceof Blob) ||
        !error.response.data.type.includes('application/json')
    ) {
        return undefined;
    }
    try {
        const reportErrors = JSON.parse(await readBlobText(error.response.data)) as ReportErrors;
        return reportErrors.errors?.find(({ key }) => key === REPORT_FAILED_ERROR_KEY)?.description;
    } catch {
        // Тело не разобрать — показываем общую ошибку скачивания вместо списка логинов.
        return undefined;
    }
};

export const downloadSegmentsReport =
    ({ logins, dateFrom, dateTo }: DownloadSegmentsReportParams): AppThunkAction<Promise<void>> =>
    async (dispatch, getState) => {
        const params = new URLSearchParams({ logins, dateFrom, dateTo });
        try {
            await fileDownload(`${SEGMENTS_REPORT_URL}?${params.toString()}`);
        } catch (error) {
            const trls = getState().translations.trls;
            const failedLogins = await getFailedLogins(error);
            dispatch(
                addMagritteCustomNotification({
                    type: MagritteNotificationType.Error,
                    text: failedLogins
                        ? translate(trls, TrlKeys.failed, [failedLogins])
                        : translate(trls, TrlKeys.downloadError),
                })
            );
        }
    };
